import { acpMoneyGramAppStates } from './states';

export default (appModule) => {
  appModule.config(acpMoneyGramAppStates);
};
